import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Aos from "aos";
import "aos/dist/aos.css";
import Logo from "../images/premier-energies.png";
import Aboutmenu from "../images/aboutmenu.jpg";
import Arrow from "../images/wback-arrow.png";

export const Header = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
    window.addEventListener("scroll", changeBackground);
    return () => {
      window.removeEventListener("scroll", changeBackground);
    };
  }, []);

  const [menus, setActive] = useState("false");
  const [megamenu, setActive1] = useState("false");
  const [megamenus, setActive2] = useState("false");
  const [header, setNavbar] = useState(false);
  const [showModal, setShowModal] = useState(false); // Modal state

  const handleToggle = () => setActive(!menus);
  const handleToggle1 = () => setActive1(!megamenu);
  const handleToggle2 = () => setActive2(!megamenus);
  const handleModalOpen = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);

  const changeBackground = () => {
    if (window.scrollY >= 80) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  const location = useLocation();
  const isDetailPage =
    location.pathname.startsWith("/investor-relations/") &&
    location.pathname !== "/investor-relations";

  return (
    <>
      <header>
        <div className={header ? "header fixed" : "header"}>
          <div className="container">
            <div className="row">
              <div className="col-lg-2 col-3 d-flex align-items-center">
                <div
                  className="logo"
                  data-aos="fade"
                  data-aos-offset="200"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <NavLink to="/">
                    <img src={Logo} alt="Premier Energies" />
                  </NavLink>
                </div>
              </div>
              <div className="col-lg-10 col-9 a-center d-flex align-items-end justify-content-end">
                <div className="navbar">
                  <div className={menus ? "menus" : "menus active"}>
                    <ul className="d-flex align-items-center toplinks">
                      <li className="desktop-show">
                        <NavLink to="/" exact="true">Home</NavLink>
                      </li>
                      <li className="desktop-show">
                        <NavLink to="/about-premier-energies">About Us</NavLink>
                        <div className="submenu">
                          <div className="container">
                            <div className="submenuchild">
                              <div className="smenu">
                                <ul>
                                  <li><a href="https://premierenergies.com/about-premier-energies#overview">OVERVIEW</a></li>
                                  <li><a href="https://premierenergies.com/about-premier-energies#infrastructure">INFRASTRUCTURE</a></li>
                                  <li><a href="https://premierenergies.com/about-premier-energies#our-ethos">Ethos</a></li>
                                  <li><a href="https://premierenergies.com/about-premier-energies#our-journey">Journey</a></li>
                                  <li><a href="https://premierenergies.com/about-premier-energies#our-leadership">Leadership</a></li>
                                  <li><a href="https://premierenergies.com/about-premier-energies#awards-recognitions">Awards & Recognitions</a></li>
                                </ul>
                              </div>
                              <div className="simg">
                                <img src={Aboutmenu} alt="Premier Product" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="desktop-show">
                        <NavLink to="/products/solar-cell">Solar Cell</NavLink>
                      </li>
                      <li className="desktop-show">
                        <NavLink to="/products/solar-module">Solar Module</NavLink>
                      </li>
                      <li className="desktop-show">
                        <NavLink to="/sustainbility">SUSTAINABILITY</NavLink>
                      </li>
                      <li className="desktop-show">
                        <NavLink
                          to="/investor-relations"
                          className={isDetailPage ? "investor-detail-page" : ""}
                        >
                          Investor Relations
                        </NavLink>
                      </li>
                      <li className="desktop-show">
                        <NavLink to="/contact-us">Contact Us</NavLink>
                      </li>
                      <li className="desktop-show">
                        <NavLink to="/enquiry">ENQUIRE NOW</NavLink>
                      </li>
                      {/* New Menu */}
                       {/* <li className="desktop-show">
                        <button
                          className="btn btn-primary"
                          style={{ padding: "6px 12px", borderRadius: "4px", cursor: "pointer" }}
                          onClick={handleModalOpen}
                        >
                          Make Enquiry
                        </button>
                      </li>   */}

                      <li>
                        <button
                          onClick={handleToggle}
                          className={menus ? "hemburgur" : "hemburgur active"}
                        >
                          <span></span>
                          <span></span>
                          <span></span>
                        </button>
                      </li>
                    </ul>

                    <div className="menuslide">
                      <div className="container">
                        <div className="togmenu">
                          <ul>
                            <li><NavLink to="/certification">Certifications</NavLink></li>
                            <li><NavLink to="/career">Career</NavLink></li>
                            <li><NavLink to="/newsroom">Newsroom</NavLink></li>
                          </ul>
                        </div>

                        <div className="mobilemene mobile-show">
                          <ul>
                            <li><NavLink to="/">Home</NavLink></li>
                            <li
                              onClick={handleToggle2}
                              className={megamenus ? "menclicks" : "menclicks active"}
                            >
                              <span>
                                About us <img src={Arrow} alt="premier arrow" />
                              </span>
                              <ul className={megamenus ? "megamenus" : "megamenus active"}>
                                <li>
                                  <span className="backbtn">
                                    Back <img src={Arrow} alt="premier back arrow" />
                                  </span>
                                </li>
                                <li><a href="https://premierenergies.com/about-premier-energies#overview">OVERVIEW</a></li>
                                <li><a href="https://premierenergies.com/about-premier-energies#infrastructure">INFRASTRUCTURE</a></li>
                                <li><a href="https://premierenergies.com/about-premier-energies#our-ethos">Ethos</a></li>
                                <li><a href="https://premierenergies.com/about-premier-energies#our-journey">Journey</a></li>
                                <li><a href="https://premierenergies.com/about-premier-energies#our-leadership">Leadership</a></li>
                                <li><a href="https://premierenergies.com/about-premier-energies#awards-recognitions">Awards & Recognitions</a></li>
                              </ul>
                            </li>
                            <li><a href="/products/solar-cell">Solar Cell</a></li>
                            <li><a href="/products/solar-module">Solar Module</a></li>
                            <li><NavLink to="/sustainbility">SUSTAINABILITY</NavLink></li>
                            <li><NavLink to="/investor-relations">Investor Relations</NavLink></li>
                            <li><NavLink to="/certification">Certifications</NavLink></li>
                            <li><NavLink to="/career">Career</NavLink></li>
                            <li><NavLink to="/newsroom">Newsroom</NavLink></li>
                            <li><NavLink to="/contact-us">Contact Us</NavLink></li>
                            {/* Mobile - Make Enquiry */}
                            {/* <li>
                              <button
                                className="btn btn-primary"
                                style={{ padding: "6px 12px", borderRadius: "4px", cursor: "pointer" }}
                                onClick={handleModalOpen}
                              >
                                Make Enquiry
                              </button>
                            </li> */}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Enquiry Modal */}
      {showModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Make Enquiry</h5>
                <button type="button" className="btn-close" onClick={handleModalClose}></button>
              </div>
              <div className="modal-body" style={{ height: "80vh" }}>
                <iframe
                  src="https://page-velocity-4445--uat.sandbox.my.salesforce-sites.com/"
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  title="Enquiry Form"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
